module.exports = __webpack_public_path__ + "static/media/download.00b35d37.svg";